export function isIncluded(products, product) {
  for (let pro of products) {
    if (pro.id === product.id) {
      return true;
    }
  }
  return false;
}
